module.exports = __webpack_public_path__ + "static/media/team-mike.86fff792.jpg";